const r=async(r,n,t)=>{if(r)try{const t=Array.isArray(n)?n:[n];await r.update({enrichments:t})}catch(r){t&&t("error","Error adding enrichment: ".concat(r),"high","uniform")}};export{r as updateEnrichments};
